import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Step, Icon } from "semantic-ui-react";
import Link from "~/components/element/Link";

@observer
class StepsHeader extends Component {
  render() {
    const { photoEditingJobId, currentStepIndex, canUpload, canReviewImages, canReviewJob, clickCallback } = this.props;

    return (
      <Step.Group>
        <Link
          as={Step}
          link
          to={`/${photoEditingJobId}/upload`}
          onClick={clickCallback ? () => clickCallback("UPLOAD_PAGE") : null}
          active={currentStepIndex === 0}
          disabled={!canUpload}
        >
          <Icon name="image" />
          <Step.Content>
            <Step.Title>Upload Images</Step.Title>
          </Step.Content>
        </Link>
        <Link
          as={Step}
          link
          to={`/${photoEditingJobId}/images`}
          onClick={clickCallback ? () => clickCallback("REVIEW_IMAGES_PAGE") : null}
          active={currentStepIndex === 1}
          disabled={!canReviewImages}
        >
          <Icon name="check circle" />
          <Step.Content>
            <Step.Title>Review Images</Step.Title>
          </Step.Content>
        </Link>
        <Link
          as={Step}
          link
          to={`/${photoEditingJobId}/review`}
          onClick={clickCallback ? () => clickCallback("REVIEW_JOB_PAGE") : null}
          active={currentStepIndex === 2}
          disabled={!canReviewImages || !canReviewJob}
        >
          <Icon name="credit card outline" />
          <Step.Content>
            <Step.Title>Review Job</Step.Title>
          </Step.Content>
        </Link>
      </Step.Group>
    );
  }
}

StepsHeader.propTypes = {
  photoEditingJobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  canUpload: PropTypes.bool,
  canReviewImages: PropTypes.bool,
  canReviewJob: PropTypes.bool,
  // will be passed when scoped to a tour, outside react-router scope
  clickCallback: PropTypes.func,
};

StepsHeader.defaultProps = {
  canUpload: true,
  canReviewImages: true,
  canReviewJob: true,
};

export default StepsHeader;

const Steps = {
  UPLOAD: 0,
  REVIEW_IMAGES: 1,
  REVIEW_JOB: 2,
};

export { Steps };
